module.exports = __webpack_public_path__ + "media/images/meta/clubpilates_aus/apple-touch-icon_alt-5a5b33332b8d790610cb039abcc3d057.png";